import { createGlobalStyle } from 'styled-components'
import NamuPro from "assets/fonts/NamuPro.ttf";

export const GlobalStyle = createGlobalStyle`
    @font-face {
        font-family: Inter;
        font-style: normal;
        font-weight: 400;
        //src: url(${NamuPro});
        src: url('https://fonts.googleapis.com/css2?family=Inter:opsz,wght@8..144,100..900&display=swap');
    }
    body {
        width: 100%;
        height: 100%;
        font-family: Inter,sans-serif;
        //letter-spacing: 0.6px;
        //font-family: 'NamuPro', sans-serif;
    }
`